import { render, staticRenderFns } from "./order-input.vue?vue&type=template&id=f3a44148&scoped=true&"
import script from "./order-input.vue?vue&type=script&lang=js&"
export * from "./order-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a44148",
  null
  
)

export default component.exports